// @flow
import React from 'react';
import styled from 'styled-components';
import {ThemeType} from 'trustar-2.0/types';
import logoWhite from './LogoWhite.png';
import logoBlack from './LogoBlack.png';
import {inDarkMode} from 'trustar-2.0/themes/common';
import {connect} from "react-redux";
import {theme} from 'modules/app/getters';

// Style for Main Components (things you may export)
const StyledLogoSplunkTS = styled.img`
  padding: 0 3rem 0 1rem;
  max-width: 22rem;
`;

// Bindings
type LogoSplunkTSProps = {
  theme: ThemeType,
};

const ConnectedLogo = (props: LogoSplunkTSProps) => {
    const logoSrc = props.theme === 'dark' ? logoWhite : logoBlack;
//  ----Template----
    return (
        <StyledLogoSplunkTS
          src={logoSrc}
          alt='splunk-trustar logo' />
    );
}

const mapState = state => {
  return {
    theme: theme(state),
  };
};

export const LogoSplunkTS = connect(mapState)(ConnectedLogo);



// WEBPACK FOOTER //
// ./web_modules/trustar/icons/LogoSplunkTS.js